import {
  DATE_RANGE_PRESET_LABELS,
  DateRangePresetKey,
} from "./dateRangePresets";

// Fallback presets for a Reports "daterange" parameter that does NOT configure
// its own `presets` list. Reports that do configure `presets` in their
// Metadata.parameters[] entry never see this list — see resolveConfiguredPresets
// in ./dateRangePresets.
//
// Kept separate from distributionDateOptions/commissionDateOptions so that
// "Include all Dates" stays out of Distribution and Receipts.
const DEFAULT_REPORT_PRESET_KEYS: DateRangePresetKey[] = [
  "custom",
  "thisWeek",
  "lastWeek",
  "thisMonth",
  "lastMonth",
  "last3Months",
  "last6Months",
  "last12Months",
  "lastCalendarYear",
  "allDates",
];

export const reportDateOptions = DEFAULT_REPORT_PRESET_KEYS.map((value) => ({
  label: DATE_RANGE_PRESET_LABELS[value],
  value,
}));
